module.exports = __webpack_public_path__ + "static/media/reformer1.c5c2f01a.jpg";